'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var prepareParams = function prepareParams() {
  var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var isCorrectPaths = Array.isArray(paths);
  var isCorrectRules = Array.isArray(rules);

  if (!isCorrectPaths) {
    paths = typeof paths === 'string' ? [paths] : [];
  }

  if (!isCorrectRules) {
    rules = typeof rules === 'string' ? [rules] : [];
  }

  return { paths: paths, rules: rules };
};

var filterPaths = function filterPaths() {
  var pathsParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var rulesParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isValidRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var params = prepareParams(pathsParams, rulesParams);
  var paths = params.paths,
      rules = params.rules;


  return paths.filter(function (item) {
    var path = item.path.trim();

    if (!path.length) {
      return false;
    }

    return rules.some(function (regex) {
      return regex.test(path);
    }) === isValidRules;
  });
};

exports.default = filterPaths;